import React, { useState, useCallback, useEffect, useRef } from 'react';

export interface DashboardModalsState {
  showShareModal: boolean;
  showWorkflowModal: boolean;
  showExportMenu: boolean;
  showOutOfCreditsModal: boolean;
}

export interface UseDashboardModalsReturn extends DashboardModalsState {
  openShareModal: () => void;
  closeShareModal: () => void;
  openWorkflowModal: () => void;
  closeWorkflowModal: () => void;
  openExportMenu: () => void;
  closeExportMenu: () => void;
  toggleExportMenu: () => void;
  openOutOfCreditsModal: () => void;
  closeOutOfCreditsModal: () => void;
  exportMenuRef: React.RefObject<HTMLDivElement>;
}

export const useDashboardModals = (): UseDashboardModalsReturn => {
  const [showShareModal, setShowShareModal] = useState(false);
  const [showWorkflowModal, setShowWorkflowModal] = useState(false);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [showOutOfCreditsModal, setShowOutOfCreditsModal] = useState(false);
  const exportMenuRef = useRef<HTMLDivElement>(null);

  // Close export menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (exportMenuRef.current && !exportMenuRef.current.contains(event.target as Node)) {
        setShowExportMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const openShareModal = useCallback(() => setShowShareModal(true), []);
  const closeShareModal = useCallback(() => setShowShareModal(false), []);

  const openWorkflowModal = useCallback(() => setShowWorkflowModal(true), []);
  const closeWorkflowModal = useCallback(() => setShowWorkflowModal(false), []);

  const openExportMenu = useCallback(() => setShowExportMenu(true), []);
  const closeExportMenu = useCallback(() => setShowExportMenu(false), []);
  const toggleExportMenu = useCallback(() => setShowExportMenu(prev => !prev), []);

  const openOutOfCreditsModal = useCallback(() => setShowOutOfCreditsModal(true), []);
  const closeOutOfCreditsModal = useCallback(() => setShowOutOfCreditsModal(false), []);

  return {
    showShareModal,
    showWorkflowModal,
    showExportMenu,
    showOutOfCreditsModal,
    openShareModal,
    closeShareModal,
    openWorkflowModal,
    closeWorkflowModal,
    openExportMenu,
    closeExportMenu,
    toggleExportMenu,
    openOutOfCreditsModal,
    closeOutOfCreditsModal,
    exportMenuRef,
  };
};
